import * as Highcharts from "highcharts";

import { MONTHS_ARRAY } from "./constants";
import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import weekOfYear from "dayjs/plugin/weekOfYear";

dayjs.extend(weekOfYear);
dayjs.extend(utc);

const getChartDataAndCategories = ({
    start_date,
    end_date,
    metrics,
    events_map
}) => {
    const chartData = { categories: [], series: [] };
    const categoriesArr = [];

    let startDay = dayjs(start_date);
    const endDay = dayjs(end_date);

    while (startDay.isBefore(endDay) || startDay.isSame(endDay)) {
        categoriesArr.push(startDay.format("YYYY-MM-DD"));

        startDay = startDay.add(1, "day");
    }

    metrics?.map((metric, idx) => {
        chartData.series.push({
            name : events_map?.[metric] || metric,
            type : "spline",
            data : new Array(categoriesArr.length).fill(0),
            color: String(Highcharts?.getOptions()?.colors?.[idx])
        });
    });

    return { chartData, categoriesArr };
};

export const getChartDataUsage = ({
    start_date,
    end_date,
    data,
    metrics,
    events_map
}) => {
    // Return if start_date or end_date is not provided
    if (!start_date || !end_date) {
        return { categories: [], series: [] };
    }

    // Convert events_map array to an object
    const eventsMapObject = Array.isArray(events_map) ? events_map.reduce((acc, { id, label }) => {
        acc[id] = label;
        return acc;
    }, {}) : events_map || {};

    const { chartData, categoriesArr } = getChartDataAndCategories({
        start_date,
        end_date,
        metrics,
        events_map: eventsMapObject // Pass the converted object
    });

    data.forEach((item) => {
        const date = dayjs(item.created_at).format("YYYY-MM-DD");
        const index = categoriesArr.indexOf(date);
        const metric = item.event;

        if (index === -1) return;

        const idxMetric = chartData.series.findIndex(
            (series) => series.name === (eventsMapObject[metric] || metric)
        );

        if (idxMetric === -1) return;
        chartData.series[idxMetric].data[index] = Number(item?.count) || 0;
    });

    chartData.categories = categoriesArr;

    return chartData;
};

export const getChartDataActiveUsers = ({
    start_date,
    end_date,
    data,
    metrics,
    events_map
}) => {
    // Return if start_date or end_date is not provided
    if (!start_date || !end_date) {
        return { categories: [], series: [] };
    }

    const { chartData, categoriesArr } = getChartDataAndCategories({
        start_date,
        end_date,
        metrics,
        events_map
    });

    data.forEach((item) => {
        const date = dayjs(item.date).format("YYYY-MM-DD");
        const index = categoriesArr.indexOf(date) - 1;

        if (index === -1) return;

        metrics.map((metric) => {
            const idxMetric = chartData.series.findIndex(
                (series) => series.name === events_map?.[metric]
            );

            if (idxMetric === -1) return;

            chartData.series[idxMetric].data[index] = Number(item?.[metric]) || 0;
        });
    });

    chartData.categories = categoriesArr;

    return chartData;
};

export const getPastSixMonthsData = () => {
    const dataArr = [];
    let x = 0;

    // Get Data for 6 months
    for (let i = 1; i <= 6; i++) {
        let startDate = dayjs()
            .subtract(6 - i, "months")
            .startOf("month");

        const endOfMonth = dayjs()
            .subtract(6 - i, "months")
            .endOf("month");

        const currMonth = startDate.month();
        const dataMonth = {
            name: MONTHS_ARRAY[currMonth],
            keys: ["x", "y", "value", "week", "date"],
            data: []
        };

        let y = startDate.day();

        while (startDate.isBefore(endOfMonth) || startDate.isSame(endOfMonth)) {
            const weekOfYear = startDate.week();
            const dateOfMonth = startDate;

            // After 7 days reset x and y axis
            if (y > 6) {
                y = 0;
                x++;
            }

            dataMonth.data.push({
                x,
                y,
                value: 0,
                week : weekOfYear,
                date : dateOfMonth.toDate()
            });

            startDate = startDate.add(1, "day");
            y++;
        }

        // increment x again
        x += 2;

        dataArr.push(dataMonth);
    }

    return dataArr;
};

export const getHeapMapData = ({ pastSixMonthsData, data }) => {
    if (!data.length) return pastSixMonthsData;

    data.forEach((item) => {
        const month = dayjs(item.date).month();
        const date = dayjs(item.date).date() - 1;
        const count = item.count || 0;
        const idxMonth = pastSixMonthsData.findIndex(
            (el) => el.name === MONTHS_ARRAY[month]
        );

        pastSixMonthsData[idxMonth].data[date].value = count;
    });

    return pastSixMonthsData;
};
